import { useToggle } from "hooks/useToggle";
import ProgressBar from "ds/components/ProgressBar";
import Box from "ds/components/Box";
import CollapsibleSection from "ds/components/CollapsibleSection";
import useUserGuideGroups from "shared/UserGuides/useUserGuideGroups";
import LearnLimitedAccessBanner from "components/LearnLimitedAccessBanner";

import LaunchPadLearnCertificatePreview from "./CertificatePreview";
import LaunchPadLearnContinueMissionButton from "./ContinueMissionButton";
import LaunchPadLearnGroupTile from "./GroupTile";
import LaunchPadLearnSkeleton from "./Skeleton";
import styles from "./styles.module.css";

const LaunchPadLearn = () => {
  const [isCollapsed, handleToggle] = useToggle(false);

  const { userGuideGroups, userGuidesCompletedCount, userGuidesCount, loading } =
    useUserGuideGroups();

  const groupTiles =
    loading && !userGuideGroups ? (
      <LaunchPadLearnSkeleton />
    ) : (
      userGuideGroups?.map(
        ({
          id,
          name,
          icon,
          color,
          skillLevel,
          description,
          timeToComplete,
          guidesCount,
          guidesCompletedCount,
        }) => (
          <LaunchPadLearnGroupTile
            key={id}
            id={id}
            title={name}
            icon={icon}
            iconColor={color}
            to={`/launchpad/learn/${id}`}
            skillLevel={skillLevel || undefined}
            description={description}
            timeToComplete={timeToComplete}
            guidesCount={guidesCount}
            guidesCompletedCount={guidesCompletedCount}
          />
        )
      )
    );

  return (
    <CollapsibleSection
      title="Learn"
      className={styles.section}
      onToggle={handleToggle}
      isCollapsed={isCollapsed}
      headerSuffix={
        <Box align="center" gap="medium">
          <ProgressBar
            ariaLabel="Number of completed features"
            max={userGuidesCount}
            current={userGuidesCompletedCount}
            isPercentage
          />
          <LaunchPadLearnContinueMissionButton />
        </Box>
      }
      ariaLevel={2}
      ariaLabel="Learn"
    >
      <LearnLimitedAccessBanner storageKey="launchpad-learn-access-notice" margin="0 0 large 0" />
      <Box className={styles.learnContent} grid gap="x-large">
        <Box direction="column" gap="medium" zeroMinWidth data-userflow-id="learn-missions">
          {groupTiles}
        </Box>
        <Box relative className={styles.certificatesColumn}>
          <LaunchPadLearnCertificatePreview userGuideGroups={userGuideGroups} />
        </Box>
      </Box>
    </CollapsibleSection>
  );
};

export default LaunchPadLearn;
